import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DeviceForm from "./DeviceForm";

const EditDevice = () => {
  const params = useParams();
  const deviceId = params.deviceId;

  const [data, setData] = useState();

  const getDevice = async () => {
    axios
      .get(`/device/` + deviceId, {
        withCredentials: true,
      })
      .then((res) => {
        setData(res.data?.result);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
  };

  useEffect(() => {
    getDevice();
  }, []);

  return <>{data && <DeviceForm mode="edit" data={data} />}</>;
};

export default EditDevice;
